import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AutoSizer, CellMeasurer, CellMeasurerCache, Grid } from 'react-virtualized';
import _ from 'lodash';

const DEFAULT_PHOTO_HEIGHT = 200;
const DEFAULT_PHOTO_WIDTH = 200;
const MARGIN_SPACE = 20;

class VirtualizedPhotoListHorizontal extends Component {
  constructor(props) {
    super(props);

    this.cache = new CellMeasurerCache({
      defaultWidth: DEFAULT_PHOTO_WIDTH,
      defaultHeight: DEFAULT_PHOTO_HEIGHT + MARGIN_SPACE,
      fixedHeight: true,
    });

    this.rowCount = 1;
    this.listRef = null;

    this.renderListItem = this.renderListItem.bind(this);
    this.recompute = this.recompute.bind(this);
  }

  recompute() {
    if (this.listRef) {
      this.cache.clearAll();
      this.listRef.recomputeGridSize();
    }
  }

  renderListItem({ columnIndex, key, parent, style }) {
    const { collection, renderItem } = this.props;

    const item = collection[columnIndex];

    if (item) {
      return (
        <CellMeasurer
          cache={this.cache}
          columnIndex={columnIndex}
          key={key}
          overscanColumnCount={10}
          parent={parent}
          rowIndex={0}
        >
          <div style={style}>{renderItem(item, columnIndex)}</div>
        </CellMeasurer>
      );
    }

    return null;
  }

  render() {
    const { collection, heightOfRow, widthOfColumn } = this.props;
    const { rowHeight } = this.cache;
    const itemsCount = _.size(collection);

    const gridHeight = heightOfRow || DEFAULT_PHOTO_HEIGHT;

    return (
      <div
        className="virtualized-photo-list-horizontal"
        style={{ height: gridHeight + MARGIN_SPACE }}
      >
        <AutoSizer>
          {({ height, width }) => (
            <Grid
              cellRenderer={this.renderListItem}
              columnCount={itemsCount}
              columnWidth={widthOfColumn + MARGIN_SPACE}
              height={height}
              rowCount={this.rowCount}
              rowHeight={rowHeight}
              width={width}
              ref={listRef => {
                this.listRef = listRef;
              }}
            />
          )}
        </AutoSizer>
      </div>
    );
  }
}

VirtualizedPhotoListHorizontal.propTypes = {
  collection: PropTypes.arrayOf(PropTypes.any).isRequired,
  heightOfRow: PropTypes.number,
  renderItem: PropTypes.func.isRequired,
  widthOfColumn: PropTypes.number,
};

VirtualizedPhotoListHorizontal.defaultProps = {
  heightOfRow: 200,
  widthOfColumn: 200,
};

export default VirtualizedPhotoListHorizontal;
